import { AxiosResponse } from 'axios';

import { Image } from '../pages/add-product/index.type';
import { axiosInstance } from './axios.config';
import { ResponseREST } from './response.type';

interface ResponseSuccessPostUploadImage extends ResponseREST {
  data: {
    images: Array<Image>;
  };
}

export const postUploadImage = async (
  FormData: FormData
): Promise<ResponseSuccessPostUploadImage> => {
  return axiosInstance
    .post('image/upload', FormData, {
      headers: {
        'Content-type': 'multipart/form-data'
      }
    })
    .then((res: AxiosResponse<ResponseSuccessPostUploadImage>) => res.data)
    .catch((err) => err);
};
